<div class="container mt-3">
  <div class="row">
    <div class="col-12">
      <mat-tab-group mat-align-tabs="start">
        <mat-tab style="color: white" label="All Certificate">
          <div class="container mt-2">
            <div class="row mt-1">
              <div class="col-md-4 mb-3">
                <mat-card class="example-card mb-3">
                  <mat-card-header>
                    <div mat-card-avatar class="example-header-image-ibm"></div>
                    <mat-card-title>Python for Data Science</mat-card-title>
                  </mat-card-header>
                  <div class="mt-1 img_four"></div>
                  <mat-card-content>
                    <p>
                      Le détenteur de badge est capable d’écrire ses propres scripts Python et d’effectuer des analyses
                      de données pratiques de base en utilisant l’environnement de laboratoire Jupyter d’IBM.
                    </p>
                  </mat-card-content>
                  <mat-card-actions>
                    <a type="button" class="btn_ref btn-block"
                       href="https://www.youracclaim.com/badges/57efc108-2ac7-4070-8229-ab415e5fede0?source=linked_in_profile"
                       mdbBtn color="info" mdbWavesEffect>Voir La Reference</a>
                  </mat-card-actions>
                </mat-card>
              </div>
              <div class="col-md-4 mb-3">
                <mat-card class="example-card mb-2">
                  <mat-card-header>
                    <div mat-card-avatar class="example-header-image-ibm"></div>
                    <mat-card-title>Data Analysis Using Python</mat-card-title>
                  </mat-card-header>
                  <div class="mt-1 img_four"></div>

                  <mat-card-content>
                    <p>
                      comprend les étapes essentielles nécessaires pour analyser les données en Python à l’aide de
                      tableaux multidimensionnels, manipuler les DataFrames dans les pandas,
                    </p>
                  </mat-card-content>
                  <mat-card-actions>
                    <a type="button" class="btn_ref btn-block"
                       href="https://www.youracclaim.com/badges/19107ae0-7969-40ec-9a2a-b45b87361326?source=linked_in_profile"
                       mdbBtn color="info" mdbWavesEffect>Voir La Reference</a>
                  </mat-card-actions>
                </mat-card>
              </div>
              <div class="col-md-4 mb-3">
                <mat-card class="example-card mb-2">
                  <mat-card-header>
                    <div mat-card-avatar class="example-header-image-an"></div>
                    <mat-card-title>Java for Android</mat-card-title>
                  </mat-card-header>
                  <div class="mt-1 img_four"></div>

                  <mat-card-content>
                    <p>
                      Ce MOOC vous enseigne comment programmer les fonctions de base et les classes du langage de
                      programmation Java qui sont utilisés dans Android, qui est la plate-forme dominante pour le
                      développement et le déploiement d’applications pour appareils mobiles.
                    </p>
                  </mat-card-content>
                  <mat-card-actions>
                    <a type="button" class="btn_ref btn-block"
                       href="https://www.coursera.org/account/accomplishments/verify/2SPE7R96NLF7" mdbBtn color="info"
                       mdbWavesEffect>Voir La Reference</a>
                  </mat-card-actions>
                </mat-card>
              </div>
              <div class="col-md-4 mb-3">
                <mat-card class="example-card mb-2">
                  <mat-card-header>
                    <div mat-card-avatar class="example-header-image-an"></div>
                    <mat-card-title>Android App Components - Intents, Activities, and Broadcast Receivers
                    </mat-card-title>
                  </mat-card-header>
                  <div class=" img_four"></div>

                  <mat-card-content>
                    <p>
                      Ce MOOC de 4 semaines s’appuie sur l’aperçu de Java et Android couvert dans le cours 1 en
                      approfondissant les composants de base de l’application Android, tels que intent, activities
                      and broadcast receivers.
                    </p>
                  </mat-card-content>
                  <mat-card-actions>
                    <a type="button" class="btn_ref btn-block mt-2"
                       href="https://www.coursera.org/account/accomplishments/verify/73CTG88E7SNB" mdbBtn color="info"
                       mdbWavesEffect>Voir La Reference</a>
                  </mat-card-actions>
                </mat-card>
              </div>
              <div class="col-md-4 mb-3">
                <mat-card class="example-card mb-2">
                  <mat-card-header>
                    <div mat-card-avatar class="example-header-image-bright"></div>
                    <mat-card-title>Angular Framework</mat-card-title>
                  </mat-card-header>
                  <div class="mt-1 img_four"></div>

                  <mat-card-content>
                    <p>
                      Appris toutes les connaissances nécessaires pour développer une application Web avec le framework
                      Angular de la version 2 à la version 11, 36h d’apprentissage pratique à 100%.
                    </p>
                  </mat-card-content>
                  <mat-card-actions>
                    <a type="button" class="btn_ref btn-block"
                       href="https://brightcoding.dev/profile/yassine-abidar/3b0f8380-7b39-11eb-951e-19b9759811f5" mdbBtn color="info"
                       mdbWavesEffect>Voir La Reference</a>
                  </mat-card-actions>
                </mat-card>
              </div>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Android Developpment">
          <div class="container mt-2">
            <div class="row mt-1">
              <div class="col-md-4 mb-3">
                <mat-card class="example-card mb-2">
                  <mat-card-header>
                    <div mat-card-avatar class="example-header-image-an"></div>
                    <mat-card-title>Java for Android</mat-card-title>
                  </mat-card-header>
                  <div class="mt-1 img_four"></div>

                  <mat-card-content>
                    <p>
                      Ce MOOC vous enseigne comment programmer les fonctions de base et les classes du langage de
                      programmation Java qui sont utilisés dans Android, qui est la plate-forme dominante pour le
                      développement et le déploiement d’applications pour appareils mobiles.
                    </p>
                  </mat-card-content>
                  <mat-card-actions>
                    <a type="button" class="btn_ref btn-block"
                       href="https://www.coursera.org/account/accomplishments/verify/2SPE7R96NLF7" mdbBtn color="info"
                       mdbWavesEffect>Voir La Reference</a>
                  </mat-card-actions>
                </mat-card>
              </div>
              <div class="col-md-4 mb-3">
                <mat-card class="example-card mb-2">
                  <mat-card-header>
                    <div mat-card-avatar class="example-header-image-an"></div>
                    <mat-card-title>Android App Components - Intents, Activities, and Broadcast Receivers
                    </mat-card-title>
                  </mat-card-header>
                  <div class=" img_four"></div>

                  <mat-card-content>
                    <p>
                      Ce MOOC de 4 semaines s’appuie sur l’aperçu de Java et Android couvert dans le cours 1 en
                      approfondissant les composants de base de l’application Android, tels que intent, activities
                      and broadcast receivers.
                    </p>
                  </mat-card-content>
                  <mat-card-actions>
                    <a type="button" class="btn_ref btn-block mt-2"
                       href="https://www.coursera.org/account/accomplishments/verify/73CTG88E7SNB" mdbBtn color="info"
                       mdbWavesEffect>Voir La Reference</a>
                  </mat-card-actions>
                </mat-card>
              </div>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Python && Data Science">
          <div class="container mt-2">
            <div class="row mt-1">
              <div class="col-md-4 mb-3">
                <mat-card class="example-card mb-3">
                  <mat-card-header>
                    <div mat-card-avatar class="example-header-image-ibm"></div>
                    <mat-card-title>Python for Data Science</mat-card-title>
                  </mat-card-header>
                  <div class="mt-1 img_four"></div>
                  <mat-card-content>
                    <p>
                      Le détenteur de badge est capable d’écrire ses propres scripts Python et d’effectuer des analyses
                      de données pratiques de base en utilisant l’environnement de laboratoire Jupyter d’IBM.
                    </p>
                  </mat-card-content>
                  <mat-card-actions>
                    <a type="button" class="btn_ref btn-block"
                       href="https://www.youracclaim.com/badges/57efc108-2ac7-4070-8229-ab415e5fede0?source=linked_in_profile"
                       mdbBtn color="info" mdbWavesEffect>Voir La Reference</a>
                  </mat-card-actions>
                </mat-card>
              </div>
              <div class="col-md-4 mb-3">
                <mat-card class="example-card mb-2">
                  <mat-card-header>
                    <div mat-card-avatar class="example-header-image-ibm"></div>
                    <mat-card-title>Data Analysis Using Python</mat-card-title>
                  </mat-card-header>
                  <div class="mt-1 img_four"></div>

                  <mat-card-content>
                    <p>
                      Cette personne comprend les étapes essentielles nécessaires pour analyser les données en Python à
                      l’aide de tableaux multidimensionnels, manipuler les DataFrames dans les pandas,
                    </p>
                  </mat-card-content>
                  <mat-card-actions>
                    <a type="button" class="btn_ref btn-block"
                       href="https://www.youracclaim.com/badges/19107ae0-7969-40ec-9a2a-b45b87361326?source=linked_in_profile"
                       mdbBtn color="info" mdbWavesEffect>Voir La Reference</a>
                  </mat-card-actions>
                </mat-card>
              </div>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Web Development">
          <div class="container mt-2">
            <div class="row mt-1">
              <div class="col-md-4 mb-3">
                <mat-card class="example-card mb-2">
                  <mat-card-header>
                    <div mat-card-avatar class="example-header-image-bright"></div>
                    <mat-card-title>Angular Framework</mat-card-title>
                  </mat-card-header>
                  <div class="mt-1 img_four"></div>

                  <mat-card-content>
                    <p>
                      Appris toutes les connaissances nécessaires pour développer une application Web avec le framework
                      Angular de la version 2 à la version 11, 36h d’apprentissage pratique à 100%.
                    </p>
                  </mat-card-content>
                  <mat-card-actions>
                    <a type="button" class="btn_ref btn-block"
                       href="https://brightcoding.dev/profile/yassine-abidar/3b0f8380-7b39-11eb-951e-19b9759811f5" mdbBtn color="info"
                       mdbWavesEffect>Voir La Reference</a>
                  </mat-card-actions>
                </mat-card>
              </div>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>
